<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="emailGroup" class="row">
            <mat-form-field class="col-12" appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" placeholder="Enter Email" required>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="btn btn-success yes-button" *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial
            (click)="submit()">{{data.confirmText}}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-danger yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>